<div class="filter-date">
  <div
    class="modal-header"
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutAlign.lt-md="start center"
  >
    <button
      class="icon-back mr-3 d-none d-medium"
      mat-button
      matPreffix
      mat-icon-button
      aria-label="Back"
      mat-dialog-close
    >
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <h2 class="h-medium">{{ "transactions.modal.title" | translate }}</h2>
    <h2 *ngIf="model.period" class="d-none d-medium">
      {{ model.period.start | localizedDate }} -
      {{ model.period.end | localizedDate }}
    </h2>
    <div class="close" mat-dialog-close>
      <mat-icon aria-hidden="false" aria-label="Filter">close</mat-icon>
    </div>
  </div>
  <div class="modal-content mob-fixed-button">
    <div fxLayout="row" fxLayout.lt-md="column">
      <div fxFlex="150px" fxFlex.lt-md="auto" class="list-links">
        <ul
          class="set-periods"
          fxFlexFill
          fxLayout="column"
          fxLayout.lt-md="row"
          fxLayoutAlign="space-between start"
        >
          <li fxFlex="none">
            <a (click)="definePeriod('today')">{{
              "transactions.modal.today" | translate
            }}</a>
          </li>
          <li fxFlex="none">
            <a (click)="definePeriod('yesterday')">{{
              "transactions.modal.yesterday" | translate
            }}</a>
          </li>
          <li fxFlex="none">
            <a (click)="definePeriod('last7days')">{{
              "transactions.modal.last7" | translate
            }}</a>
          </li>
          <li fxFlex="none">
            <a (click)="definePeriod('last30days')">{{
              "transactions.modal.last30" | translate
            }}</a>
          </li>
          <li fxFlex="none">
            <a (click)="definePeriod('thisMonth')">{{
              "transactions.modal.thisMonth" | translate
            }}</a>
          </li>
          <li fxFlex="none">
            <a (click)="definePeriod('lastMonth')">{{
              "transactions.modal.lastMonth" | translate
            }}</a>
          </li>
        </ul>
      </div>
      <div fxFlex>
        <div class="inlineCalendarContainer">
          <!-- <sat-calendar
            #calendar
            [rangeMode]="true"
            [startDate]="model.period.start"
            [endDate]="model.period.end"
            (dateRangesChange)="changePeriod($event)"
          >
          </sat-calendar> -->

          <!-- <mat-datepicker startView="multi-year"></mat-datepicker> -->
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" fxLayout="row" fxLayoutAlign="space-between center">
    <div *ngIf="model.period" class="h-medium">
      {{ model.period.start | localizedDate }} -
      {{ model.period.end | localizedDate }}
    </div>
    <button mat-flat-button color="primary" [mat-dialog-close]="model.period">
      <mat-icon aria-hidden="false" aria-label="Filter">calendar_today</mat-icon
      >{{ "transactions.modal.filter" | translate }}
    </button>
  </div>
</div>
